import React from 'react'
import { FiChevronDown, FiChevronRight, FiMenu, FiX } from "react-icons/fi";

export const nestedMenu =  [
    {name:'Home', path:'/home', active:true }, 
    { name:'Explore', path:'', children:[
        {name:'Landing Pages', path:'', children:[
            {name:'Job Page', path:'/home/job'},
            {name:'Green Home Page', path:'/home'},
            {name:'Pink Home Page', path:'/home/pink'},
            {name:'Base Home Page', path:'/home/base'},
            {name:'Image Hero Page', path:'/home/header'},
            {name:'Demo Page', path:'/demo'},
        ]},
        {name:'Social Media Pages', path:'#', children:[
            {name:'Profile Page', path:'/profile'}, 
            {name:'Grid Profile Page', path:'/profiles/grid'}, 
            {name:'Feed Profile Page', path:'/profiles/feed'}, 
        ]}, 
        {name:'Headers', path:'#', children:[
          {name:'Home Header', path:'/home/'},
          {name:'Original Header', path:'/home/original'},
          {name:'Main Header', path:'/home/header'},
        ]},
    ]},
     {name:'Pages', path:'#', children:[
        {name:'Category', path:'/category'},
     
         {name:'Inner Pages', path:'#', children:[
            {name:'About', path:'/about'}, 
            {name:'Faq', path:'/faq'}, 
            {name:'Contact', path:'/contact'}, 
         ]}, 
        
        {name:'Account Pages', path:'#', children:[
          {name:'Account Page', path:'/account'}, 
            {name:'Account Setting', path:'/account/setting'}, 
            {name:'Account Friendships', path:'/account/friendship'}, 
            {name:'Change Password', path:'/account/change'}, 
            {name:'Favorites Page', path:'/account/projects'}, 
        ]}, 
        {name:'Projects Page', path:'/projects'}, 
        {name:'Project Single Show Page', path:'/projects/single'}, 
        {name:'Notification Page', path:'/notifications'}, 
        {name:'404', path:'/404'}, 
        {name:'Authentication Pages', path:'#', children:[
            {name:'Sign in', path:'/signin'}, 
            {name:'Sign up', path:'/signup'}, 
        ]}, 
        {name:'Form Pages', path:'#', children:[
          {name:'Project Create & Edit Page', path:'/projects/create'}, 
          {name:'Profile Create & Edit Page', path:'/profiles/create'}, 
      ]}, 
    ]}, 
    {name:'Docs', path:'/docs'}, 
    {name:'About', path:'/About'}, 
  ]

// Homepage Navigation
export const NavbarMeganu = () =>{
    const [auth] = React.useState(false);
    return (
        <header id="opac-standard">
        <div className="lines flex-align  h70">
            <h3 className='logo'>NOVA</h3>  {/**  <a href="##"><img height="30" src="/logo/logo.png" className="logo" alt=" Logo"/></a> **/}
        </div>

        <Navmenu />

        {auth && (
            <NavProfile />
        )}
        {!auth && (
           <NavGuest />
        )}
        
    </header>
    )
}

export default NavbarMeganu;


const Navmenu = () => (
    <ul className="classic-menu">
        { nestedMenu.map((item, i)=>(
                <li className={item.active?'active':''} key={`first-${i}`}>
                    <a href={item.path}><p>{item.name}</p> {item.children? <FiChevronDown />:null } </a>
                    {item.children?.length>0 && (
                         <div className="sub" >
                            <ul className="">
                                { item.children.map((item,i)=><NavmenuITem item={item} key={`item-${i}`} />)}
                            </ul>
                        </div>
                    )}

            </li>
        ))}
    </ul>
)

export const NavmenuITem = ({item,i}) =>{
    return (
        <li>
            <a href={item?.path}>
                {!item?.children?  item.name : <p>{item.name}</p> }
                {item?.children? <FiChevronRight />:null }
            </a>
            <div className="sub" >
                <ul className="">
                    {item.children?.map((child,i)=>(
                        <li key={`child-${i}`}>
                            <a href={child?.path}>
                                {!child?.children?  child.name : <p>{child.name}</p> }
                                {child.children?.length>0 && <NavmenuITem item={child.children} />}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </li>
    )
} 


const NavProfile = () => {

    return (
        <div className="profile">

            <div className="lines flex-align h70">
                <div className="notify">
                    <a href="##">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                        <span>25</span>
                    </a>
                    <div className="notify-sub ">
                        <div className="notifications">
                            <h1>Notifications</h1>
                        </div>
                    </div>
                </div>
                <div className="notify">

                    <a href="##">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-message-circle"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
                        <span>155</span>
                    </a>
                    <div className="notify-sub">
                        <div className="messages">
                            <h1>Messages</h1>

                        </div>
                    </div>
                </div>

            </div>

            <div className="flex-align h70 myprofile">
                <a href="##">
                    <img height="50" src="/faces/1.png" alt="" className="avatar" />
                </a>
                <div className="profile-sub">
                    <div className="notifications">

                    </div>
                </div>

            </div>
 
            </div>
    )
}


const Mobilemenu = () => (
    <ul className="mobile-menu">
        { nestedMenu.map((item, i)=>(
                <li className={item.active?'active':''} key={`first-${i}`}>
                    <a href={item.path}><p>{item.name}</p> {false && item.children? <FiChevronDown />:null } </a>
                    {item.children?.length>0 && (
                         <div className="sub" >
                            <ul className="">
                                { item.children.map((item,i)=><NavmenuITem item={item} key={`item-${i}`} />)}
                            </ul>
                        </div>
                    )}

            </li>
        ))}
    </ul>
)


const NavGuest = () => {
    const [open, setOpen] = React.useState(false)

    return (
        <React.Fragment>
            <div className='flex-end '>
                <div>
                    <div className='mr-3 menubar' onClick={()=>setOpen(true)} > <FiMenu size={25} /> </div>
                    {open&&(
                        <div className='dropdown'>
                            <div className="heading flex">
                                <div className='logo'>NOVA</div>
                                <div onClick={()=>setOpen(false)} ><FiX size={33} /></div>
                            </div>
                            <Mobilemenu />
                        </div> 
                    )}
                </div>

                <div className='btn btn-black mr mobile-hide'>Create</div>

                <div className='btn outline white' onClick={()=>{}}>Sign in</div>
            </div>
        </React.Fragment>

    )
}